import React, { useState, useEffect } from "react";
import Weeks from "./Weeks";
import Months from "./Months";
import Years from "./Years";

export default function TimeWiseFilter({ setFirstdate, setLastdate, setType, start_date, end_date }) {
    const [activeTab, setActiveTab] = useState("Week");
    const [calendarComponent, setCalendarComponent] = useState(<Weeks setFirstdate={setFirstdate} setLastdate={setLastdate} />);

    useEffect(() => {
        switch (activeTab) {
            case "Week":
                setCalendarComponent(<Weeks setFirstdate={setFirstdate} setLastdate={setLastdate} />);
                break;
            case "Month":
                setCalendarComponent(<Months setFirstdate={setFirstdate} setLastdate={setLastdate} start_date={start_date} end_date={end_date} />);
                break;
            case "Year":
                setCalendarComponent(<Years setFirstdate={setFirstdate} setLastdate={setLastdate} start_date={start_date} end_date={end_date} />);
                break;
            default:
                setCalendarComponent(<Months setFirstdate={setFirstdate} setLastdate={setLastdate} start_date={start_date} end_date={end_date} />);
                break;
        }
    }, [activeTab]);
    const setTypess = (value, type) => {
        setActiveTab(value);
        setType(type)
    }

    return (
        <div >
            <div className="col-lg-10 mx-auto tab-sec">
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: 'center',
                        marginBottom: '32px'
                    }}
                    className="tab-content calendar-flex"
                >
                    <ul className="nav nav-tabs m-0">
                        <li className="nav-item">
                            <a
                                className={`nav-link ${activeTab === "Week" ? "active" : ""}`}
                                onClick={() => setTypess("Week", 1)}
                            >
                                Week
                            </a>
                        </li>
                        <li className="nav-item">
                            <a
                                className={`nav-link ${activeTab === "Month" ? "active" : ""}`}
                                onClick={() => setTypess("Month", 2)}
                            >
                                Month
                            </a>
                        </li>
                        <li className="nav-item">
                            <a
                                className={`nav-link ${activeTab === "Year" ? "active" : ""}`}
                                onClick={() => setTypess("Year", 3)}
                            >
                                Year
                            </a>
                        </li>
                    </ul>
                    <div>{calendarComponent}</div>
                </div>
            </div>
        </div>
    );
}
